import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Space,
  InputNumber,
} from "antd";
import { EditOutlined, SearchOutlined, PlusOutlined, DeleteOutlined, MailOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

export const SugestoesCadEmails = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarEmails();
  }, []);

  // LISTAR
  const listarEmails = async () => {
    setLoading(true);
    const api = await http("get", `v1/sugestoes_emails/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarProduto = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/sugestoes_emails/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarEmails();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarEmail = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/sugestoes_emails/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarEmails();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Matrícula",
      dataIndex: "matricula",
      sorter: (a, b) => a.matricula?.toString()?.localeCompare(b.matricula?.toString()),
    },
    {
      title: "E-mail",
      dataIndex: "email",
      sorter: (a, b) => a.email?.localeCompare(b.email),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarEmail(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    cadastrarProduto(formulario);
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.matricula?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.email?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> Novo E-mail
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="matricula"
                label="Matrícula"
                rules={[{ required: true, message: "Digite a matrícula!" }]}>
                <InputNumber
                  min={1}
                  precision={0}
                  size="large"
                  disabled={loading}
                  placeholder="Informe a matrícula!"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="email"
                label="E-mail"
                rules={[
                  { required: true, message: "Digite o e-mail!" },
                  { type: "email", message: "Digite um e-mail válido!" },
                ]}>
                <Input size="large" disabled={loading} placeholder="Informe o e-mail!" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Inova" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Sugestões E-mails"
              subtitle="Cadastro de e-mails para recebimento"
              icon={<MailOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table scroll={{ x: 700 }} columns={columns} dataSource={dadosFilter} size="small" />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
